module.exports = __webpack_public_path__ + "media/images/admin/icon/icon_unlock-73d996612906690ef0b0b7bd6471d7a7.svg";